import api from "../config/api";
import handleResponse from "./ResponseHandler";

function deleteAsset(
    inspectionId: string,
    assetIds: string[],
    idToken: string,
    inspectionReportId?: string
) {
    return new Promise(function (resolve, reject) {
        const options = {
            method: "DELETE",
            headers: {
                Accept: "application/json, text/plain, */*",
                idtoken: idToken,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(assetIds)
        };

        // Passing the inspectionReportId will perform a soft delete from the document link table to handle reusable 
        // document deletes 
        const queryParams = 
            inspectionReportId 
                ? `?inspectionId=${inspectionId}&inspectionReportId=${inspectionReportId}`
                : `?inspectionId=${inspectionId}`

        fetch(api.deleteAsset + queryParams, options)
            .then((response) => handleResponse(response))
            .then((response) => response.json())
            .then((data) => {
                resolve(data);
            })
            .catch((response) =>
                reject({
                    status: response.statusText,
                    statusCode: response.statusCode
                })
            );
    });
}

export default deleteAsset;
